module.exports = __webpack_public_path__ + "img/bottom opening.be329a5a.png";